import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { useViewerRegion } from '@/frontend/features/region/region-context'
import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches members with pet summaries, scoped to the active region. Supports search, limit, and offset. */
export function useListMembers(opts?: {
  q?: string
  limit?: number
  offset?: number
  includeArchived?: boolean
}) {
  const api = useOsApi()
  const { region } = useViewerRegion()
  const { q, limit, offset, includeArchived } = opts ?? {}

  return useQuery({
    queryKey: ['members', { q, limit, offset, region, includeArchived }],
    queryFn: async () => {
      const response = await api.get('/members', {
        query: { q, limit, offset, region, includeArchived },
      })
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
    placeholderData: keepPreviousData,
  })
}
